import { ReactComponent as QontySVG } from "@shared/assets/SVGs/qonty.svg";
import QontyDarkPng from "@shared/assets/PNGs/Map/qonty-darkmode.png";

interface QontyProps {
    height: string;
    width: string;
    blackAndWhite?: boolean;
    opacity?: number;
    darkMode?: boolean;
}

export const Qonty: React.FC<QontyProps> = ({
    height,
    width,
    blackAndWhite,
    opacity,
    darkMode = false,
}) => {
    const filter = blackAndWhite ? "grayscale(100%)" : "none";

    return (
        <div style={{ height, width }}>
            {darkMode ? (
                <img
                    src={QontyDarkPng}
                    alt="Qonty"
                    style={{ height: "100%", width: "100%", filter, opacity: opacity ?? 1 }}
                />
            ) : (
                <QontySVG style={{ height: "100%", width: "100%", filter, opacity: opacity ?? 1 }} />
            )}
        </div>
    );
};
